import apiClient from './apiClient';

const apiBaseURL = '/questionnaires/';
const domainsBaseURL = '/domains';
const cadragesBaseURL = '/cadrages';

export const questionnaireService = {
  /**
   * Récupère la liste de tous les questionnaires
   */
  async list(params?: { skip?: number; limit?: number }): Promise<any[]> {
    const response = await apiClient.get(apiBaseURL, { params });
    return response.data;
  },

  /**
   * Récupère un questionnaire spécifique par son ID
   * @param id - L'ID du questionnaire
   */
  async get(id: string): Promise<any> {
    const response = await apiClient.get(`${apiBaseURL}${id}`);
    return response.data;
  },

  /**
   * Crée un nouveau questionnaire
   * @param data - Les données du questionnaire à créer
   */
  async create(data: any): Promise<any> {
    const response = await apiClient.post(apiBaseURL, data);
    return response.data;
  },

  /**
   * Met à jour un questionnaire existant
   * @param id - L'ID du questionnaire à mettre à jour
   * @param data - Les données de mise à jour
   */
  async update(id: string, data: any): Promise<any> {
    const response = await apiClient.put(`${apiBaseURL}${id}`, data);
    return response.data;
  },

  /**
   * Supprime un questionnaire
   * @param id - L'ID du questionnaire à supprimer
   */
  async delete(id: string): Promise<void> {
    await apiClient.delete(`${apiBaseURL}${id}`);
  },

  /**
   * List questionnaire responses for a domain.
   */
  async listDomainResponses(domainId: string, params: { skip?: number; limit?: number } = {}): Promise<any[]> {
    const response = await apiClient.get(`${domainsBaseURL}/${domainId}/questionnaire-responses/`, { params });
    return response.data;
  },

  /**
   * Create a questionnaire response for a cadrage.
   */
  async createForCadrage(cadrageId: string, payload: any): Promise<any> {
    const response = await apiClient.post(`${cadragesBaseURL}/${cadrageId}/questionnaire-responses/`, payload);
    return response.data;
  }
};

export default questionnaireService;
